<app-spinner [show]="loading" [center]="true"></app-spinner>

<ng-container *ngIf="!loading" class="d-flex justify-content-center">
  
  <div #stickyHeader>
    <app-sticky-header
      *ngIf="claimDto"
      [claimDto]="claimDto"
      [repairTotal]="repairTotal"
      [busySubmitting]="busyUpdatingRepairCentre"
      [repairsDto]="repairs"
      [isOpen]="isStickyHeaderOpen"
      [assignedAdjuster]="assignedAdjuster" (adjusterChanged)="setAdjuster($event)"
      (stickyHeaderStateChange)="onStickyHeaderStateChange($event)"
      (updateButtonClicked)="setUpdateForRepairCentre()">
    </app-sticky-header>
  </div>

  <h1 class="h3 mb-4"><a class="link-primary" href="/adjuster/claim-list">Claims List</a> > {{claimDto?.coverageTypeGroupLabel}}</h1>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-white pb-2">
          <app-stats [ngClass]="claimDto ? 'd-block' : 'd-none'" [claimDto]="claimDto"></app-stats>
        </div>
        <div class="card-header bg-primary-dark text-light d-block d-md-flex">
          <app-vehicle-information
            [claim]="claimDto"
            class="d-block d-xl-flex">
          </app-vehicle-information>
          <div class="border-start border-white-35 d-none d-md-flex ps-md-4"></div>
          <app-warranty-information
            [warranty]="claimDto!.warranty"
            [IsAdjusterView]="true"
            class="pt-3 pt-1 pt-md-1">
          </app-warranty-information>
        </div>

        <div #claimHeader class="card-body bg-stat p-4">
          <div class="row">
            <div class="col-sm-6 col-lg-8 col-xl-9 px-3 mt-auto">
              <div class="row">
                <div class="col-12">
                  <app-duplicate-claims [claimId]="claimDto!.claimId"></app-duplicate-claims>
                </div>
                <div class="col-xl-5 mt-auto">
                  <div class="row">
                    <app-claim-status [claimDto]="claimDto!" class="col-auto mt-auto mb-3"></app-claim-status>                   
                    <app-claim-authorization-number 
                      [claimDto]="claimDto" 
                      class="col mb-3" 
                      [class.mt-auto]="!claimDto!.isLocked"
                      (pushedToE2)="refreshClaim()">
                    </app-claim-authorization-number>
                  </div>
                  <div class="row">
                    <app-assign-to [assignedAdjuster]="assignedAdjuster" (adjusterChanged)="setAdjuster($event)" [claimDto]="claimDto" class="col-12 mb-3"></app-assign-to>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-3 mt-auto mb-3 mb-md-0 mb-sm-2">
                  <app-deductible [claimDto]="claimDto!" *ngIf="claimDto?.warranty?.deductible !== null"></app-deductible>
                </div>
                <div class="col-6 col-sm-12 col-md-6 col-xl-4 mt-auto mb-3">
                  <div class="d-flex mb-1">
                    <app-is-claim-test-data class="flex-grow-1 mt-auto" [ClaimDto]="claimDto!"/>
                    <app-adjuster-delete-claim *ngIf="!claimDto!.isLocked" [claimDto]="claimDto!"/>
                  </div>
                  <app-update-button
                      *ngIf="!claimDto!.isLocked"
                      class="d-block mt-2"
                      [repairTotal]="repairTotal"
                      [isLocked]="claimDto!.isLocked"
                      [busySubmitting]="busyUpdatingRepairCentre"
                      (updateButtonClicked)="setUpdateForRepairCentre()">
                  </app-update-button>
                  <app-approve-reject 
                    *ngIf="!claimDto!.isLocked" 
                    [claimDto]="claimDto!" 
                    [customerRecordMatch]="customerRecordMatch" 
                    [assignedAdjuster]="assignedAdjuster"
                    [repairsDto]="repairs!" 
                    [repairTotal]="repairTotal"
                    (refreshClaim)="refreshClaim()">
                  </app-approve-reject>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3 mt-lg-n5 px-3">
                <div class="bg-light border border-3 border-white rounded px-4 pt-4 pb-3">
                  <app-totals [claimDto]="claimDto!" [manuallyEnteredDeductible]="claimDto!.manuallyEnteredDeductible" [repairTotal]="repairTotal"></app-totals>
                </div>
            </div>
          </div>
        </div>

        <div class="card-body p-4">
          <ng-container *ngIf="claimDto">

            <div class="row mt-3">
              <div class="col-xl-9 px-3">
                <app-internal-comments [claimDto]="claimDto"></app-internal-comments>
                <app-messages [statusUpdated]="statusUpdatedEvent" [toName]="claimDto!.submittedBy.firstName + ' ' + claimDto!.submittedBy.lastName" [refreshMessages]="refreshMessages" [isAdjusterView]="true" [claimDto]="claimDto"></app-messages>
              </div>
            </div>

            <app-customer-information
              [applicationId]="claimDto!.applicationId"
              [customerOnFile]="claimDto!.customerOnFile"
              [isAdjusterView]="true"
              [isLocked]="claimDto!.isLocked"
              (customerRecordMatchEvent)="receiveCustomerRecordMatch($event)"
            >
            </app-customer-information>
            <app-maintenance [claimDto]="claimDto"/>
            <app-repairs
              [ClaimDto]="claimDto"
              [Submitted]="submitted"
              [IsAdjusterView]="true"
              (totalUpdated)="setRepairTotal($event)"
              (repairsUpdated)="updateRepairs($event)"
            >
            </app-repairs>

            <div class="row">
              <div class="col-xl-9 px-3">
                <app-file-upload [IsAdjusterView]="true" [ClaimDto]="claimDto"></app-file-upload>
                <app-documents [ClaimDto]="claimDto" [customerOnFile]="claimDto!.customerOnFile"></app-documents>
                <ng-container *ngIf="!claimDto!.isLocked">
                  <hr class="mt-4 text-black">
                  <div class="text-end">
                    <a class="btn btn-outline-secondary btn-lg me-3" href="/">Cancel</a>
                    <button
                      class="btn btn-lg btn-primary position-relative"
                      type="button"
                      (click)="setUpdateForRepairCentre()"
                    >
                      <span
                        class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
                        role="status" aria-hidden="true" [ngClass]="{'show': busyUpdatingRepairCentre}">
                      </span>
                      <span class="text fade" [ngClass]="{'show': !busyUpdatingRepairCentre}">Update Claim</span>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-9 px-3">
                <app-calculated-logic [claimDto]="claimDto"></app-calculated-logic>
              </div>
            </div>

          </ng-container>
        </div>

      </div>
    </div>
  </div>
  
  <div *ngIf="!environment.production">
    <hr>
    <h3>Debugging</h3>
    <app-reset-claim-status [claimDto]="claimDto!" (refreshClaim)="refreshClaim()"/>
  </div>

</ng-container>
